<!-- Template -->

<template>
    <div 
        class="form-notification"
        :class="{ 'is-error': isError }" 
        v-if="message.exists">
        <p v-html="message.message"></p>
    </div>      
</template>

<script>
    import { PageMessage } from '@/models/page-message';

    export default {
        name: 'FormNotification',

        props: {
            isError: {
                type: Boolean,
                default: false                
            },
            
            message: {
                type: PageMessage,
                required: true
            }
        }
    }
</script>
